import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import {
    Box,
    FormControlLabel,
    Checkbox,
    //
} from '@mui/material';
import { PriorityList } from '.';

const ProteinPriority = ({ name, props }) => {
    const { id } = useParams();
    const { setValue, watch, getValues } = useFormContext();
    const priorityList = watch(name);
    const [checked, setChecked] = useState(false);

    const priorities = getValues('priorities') ?? {};

    useEffect(() => {
        if (priorities[name]?.length) {
            const processorInList = priorities[name].some((processor) => processor._id === id);
            setChecked(processorInList);
        }
    }, [priorities, name, id]);

    const handleCheck = () => {
        if (checked) {
            const updatedPriorityIds = priorityList.filter((processorId) => processorId !== id);
            setValue(name, updatedPriorityIds);
            setChecked(false);
        } else {
            setChecked(true);
        }
    };

    return (
        <Box>
            <FormControlLabel
                label="Protein Priority"
                sx={{ mb: 2 }}
                control={
                    <Checkbox
                        checked={checked}
                        onChange={handleCheck}
                        //
                    />
                }
                //
            />
            {checked && <PriorityList props={props} />}
        </Box>
    );
};

export default ProteinPriority;
